import { render } from "./CampaignContent.vue?vue&type=template&id=c84ca4ea&scoped=true"
import script from "./CampaignContent.vue?vue&type=script&lang=js"
export * from "./CampaignContent.vue?vue&type=script&lang=js"

import "./CampaignContent.vue?vue&type=style&index=0&id=c84ca4ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84ca4ea"]])

export default __exports__